import React from 'react' // eslint-disable-line no-unused-vars
import { Switch, Route, Redirect } from 'react-router'
import Home from './mi-app/home/Home'
import SubmitInquiry from './mi-app/submitInquiry/SubmitInquiry'
import SubmitInquiryPage from './mi-app/submitInquiry/SubmitInquiryPage'
import Search from './mi-app/Search'
import ProductsLanding from './mi-app/products/ProductsLanding'
import ProductDetails from './mi-app/products/ProductDetails'
import FindMyMSL from './mi-app/FindMyMSL'
import SiteResources from './mi-app/siteResources/SiteResources.js'
import Congresses from './mi-app/congresses/Congresses'
import StabilityTool from './mi-app/stabilityTool/StabilityTool'
import Reports from './mi-app/Reports'
import AdminPanel from './mi-app/adminPanel/AdminPanel'
import Error from './mi-app/Error'
import NoAccess from './mi-app/NoAccess'
import NotListedCountry from './mi-app/Pages/notListedCountries/NotListedCountry.js'
import NoAccessTET from './mi-app/NoAccessTET'
import EmptyPage from './pages/EmptyPage'
import AdminProductUpdate from './mi-app/adminPanel/AdminProductUpdate'
import AdminIndicationUpdate from './mi-app/adminPanel/AdminIndicationUpdate'
import AdminManageAdGroup from './mi-app/adminPanel/AdminManageAdGroup'
import AddProduct from './mi-app/adminPanel/Product_Mangement/AddProduct'
import ManageCongresses from './mi-app/adminPanel/ManageCongresses'
import ManageSiteMessages from './mi-app/adminPanel/ManageSiteMessages'
import ManageTranslationsDraft from './mi-app/adminPanel/ManageTranslationsDraft'
import EditTranslationsDraft from './mi-app/adminPanel/EditTranslationsDraft'
import ManageTranslationsLive from './mi-app/adminPanel/ManageTranslationsLive'
import ManageCountryMenu from './mi-app/adminPanel/ManageCountryMenu'
import ProtectedRoute from './ProtectedRoute'
import AccessedRoute from './AccessedRoute'
import SiteMap from './mi-app/siteMap/SiteMap'
import AboutUs from './mi-app/aboutUs/AboutUs'
import { PERMISSIONS } from './constants'
import TETUserView from './mi-app/stabilityTool/V2_TET_User_View.js'
import TETProductManagement from './mi-app/adminPanel/TET/V2TETProductManagement.js'
import TETContentManagement from './mi-app/adminPanel/TET/V2TETContentManagement.js'
import TETRulesConfiguration from './mi-app/adminPanel/TET/V2TETRulesConfiguration.js'
import TETAddProduct from './mi-app/adminPanel/TET/V2TETAddTetProduct.js'
import AffiliateVisibility from './mi-app/adminPanel/Product_Mangement/AffiliateVisibility.js'
import EditProduct from './mi-app/adminPanel/Product_Mangement/EditProduct.js'
import NewManageIndications from './mi-app/adminPanel/Product_Mangement/NewManageIndications.js'
import Allergen from './mi-app/allergen/allergen.js'
import ami from './mi-app/adminPanel/AMI/ami.js'
import V2SiteExport from './mi-app/adminPanel/V2SiteExport.js'
import UploadImage from './mi-app/adminPanel/Content Management/UploadImage.js'
import PreviewImage from './mi-app/adminPanel/Content Management/PreviewImage.js'
import CreateStaticPage from './mi-app/adminPanel/Content Management/CreateStaticPage.js'
import MenuManagement from './mi-app/adminPanel/Menu Management/MenuManagement.js'
import ManageStaticPage from './mi-app/adminPanel/Content Management/ManageStaticPage.js'
import MainPreviewPage from './mi-app/adminPanel/Content Management/Preview Page/MainPreviewPage.js'
import StaticPage from './mi-app/Pages/Static Page/StaticPage.js'
import V2_AuditHistory from './mi-app/adminPanel/V2Audit/V2_AuditHistory.js'


const Routes = () =>
  <Switch>
    <Route exact path='/' component={Home} />
    <ProtectedRoute exact path='/about-us' component={AboutUs} requiredPermission={PERMISSIONS.ABOUT_US} />
    <ProtectedRoute exact path='/submit-inquiry' component={SubmitInquiryPage} requiredPermission={PERMISSIONS.SUBMIT} />
    <ProtectedRoute exact path='/search' component={Search} requiredPermission={PERMISSIONS.SEARCH} />
    <ProtectedRoute exact path='/allergen' component={Allergen} requiredPermission={PERMISSIONS.ALLERGEN} />
    <ProtectedRoute exact path='/products' component={ProductsLanding} requiredPermission={PERMISSIONS.PRODUCTS} />
    <ProtectedRoute exact path='/products/:productId' component={ProductDetails} requiredPermission={PERMISSIONS.PRODUCTS} />
    <ProtectedRoute exact path='/find-my-msl' component={FindMyMSL} requiredPermission={PERMISSIONS.FINDMYMSL} />
    <ProtectedRoute exact path='/hcp-resources' component={SiteResources} requiredPermission={PERMISSIONS.SITERESOURCES} />
    <ProtectedRoute exact path='/site-map' component={SiteMap} requiredPermission={PERMISSIONS.PUBLIC} />
    <ProtectedRoute exact path='/congresses' component={Congresses} requiredPermission={PERMISSIONS.CONGRESSINTEGRATION} />
    <ProtectedRoute exact path='/temperature-excursion-tool' component={TETUserView} requiredPermission={PERMISSIONS.CALCULATOR} redirectPath='/noaccesstet'/>
    <ProtectedRoute exact path='/reports' component={Reports} requiredPermission={PERMISSIONS.REPORT} />
    <ProtectedRoute exact path='/admin' component={AdminPanel} requiredPermission={PERMISSIONS.ADMIN} />
    <ProtectedRoute exact path='/admin/local-products' component={AdminProductUpdate} requiredPermission={PERMISSIONS.ADMIN} />
    <ProtectedRoute exact path='/admin/affiliate-product-visibility' component={AffiliateVisibility} requiredPermission={PERMISSIONS.ADMIN} />
    <ProtectedRoute exact path='/admin/edit-products' component={EditProduct} requiredPermission={PERMISSIONS.ADMIN} />
    <ProtectedRoute exact path='/admin/new-manage-indications' component={NewManageIndications} requiredPermission={PERMISSIONS.ADMIN} />
    <ProtectedRoute exact path='/admin/indications' component={AdminIndicationUpdate} requiredPermission={PERMISSIONS.ADMIN} />
    <ProtectedRoute exact path='/admin/adgroups' component={AdminManageAdGroup} requiredPermission={PERMISSIONS.ADMIN} />
    <ProtectedRoute exact path='/admin/add-products' component={AddProduct} requiredPermission={PERMISSIONS.ADMIN} />
    <ProtectedRoute exact path='/admin/manage-congresses' component={ManageCongresses} requiredPermission={PERMISSIONS.ADMIN} />
    <ProtectedRoute exact path='/admin/manage-site-messages' component={ManageSiteMessages} requiredPermission={PERMISSIONS.ADMIN} />
    <ProtectedRoute exact path='/admin/manage-translations-draft' component={ManageTranslationsDraft} requiredPermission={PERMISSIONS.ADMIN} />
    <ProtectedRoute exact path='/admin/edit-translations-draft' component={EditTranslationsDraft} requiredPermission={PERMISSIONS.ADMIN} />
    <ProtectedRoute exact path='/admin/manage-translations-live' component={ManageTranslationsLive} requiredPermission={PERMISSIONS.ADMIN} />
    <ProtectedRoute exact path='/admin/manage-country-menu' component={MenuManagement} requiredPermission={PERMISSIONS.ADMIN} />
    <ProtectedRoute exact path='/admin/manage-tet-products' component={TETProductManagement} requiredPermission={PERMISSIONS.ADMIN} />
    <ProtectedRoute exact path='/admin/manage-tet-content' component={TETContentManagement} requiredPermission={PERMISSIONS.ADMIN} />
    <ProtectedRoute exact path='/admin/manage-tet-rule' component={TETRulesConfiguration} requiredPermission={PERMISSIONS.ADMIN} />
    <ProtectedRoute exact path='/admin/add-tet-product' component={TETAddProduct} requiredPermission={PERMISSIONS.ADMIN} />
    <ProtectedRoute exact path='/admin/ami_chatbot_admin' component={ami} requiredPermission={PERMISSIONS.ADMIN} />
    <Route exact path='/page' component={StaticPage}/>

    <ProtectedRoute exact path='/admin/upload-image' component={UploadImage} requiredPermission={PERMISSIONS.ADMIN} />
    <ProtectedRoute exact path='/admin/get-image' component={PreviewImage} requiredPermission={PERMISSIONS.ADMIN} />
    <ProtectedRoute exact path='/admin/create-static-page' component = {CreateStaticPage} requiredPermission={PERMISSIONS.ADMIN} />
    <ProtectedRoute exact path='/admin/manage-static-page' component = {ManageStaticPage} requiredPermission={PERMISSIONS.ADMIN} />
    <ProtectedRoute exact path='/admin/content-preview-page' component = {MainPreviewPage} requiredPermission={PERMISSIONS.ADMIN} />
    <ProtectedRoute exact path = '/admin/audit_history' component = {V2_AuditHistory} requiredPermission={PERMISSIONS.ADMIN}/>
    
    <ProtectedRoute exact path='/admin/site-export' component={V2SiteExport} requiredPermission={PERMISSIONS.ADMIN} />
    <Route exact path='/error' component={Error} />
    <Route path='/conference' render={() => <div className='container mt-0'><SubmitInquiry embedded='false' flowType='CONFERENCE' /></div>} />
    <AccessedRoute exact path='/scibooth' requiredPermission={PERMISSIONS.SCI_BOOTH} renderFunction={() => <div className='container mt-0'><SubmitInquiry embedded='true' flowType='SCIBOOTH' /></div>} />
    <Route exact path='/noaccess' component={NoAccess} />
    <Route exact path='/country-not-available' component={NotListedCountry} />
    <Route exact path='/noaccesstet' component={NoAccessTET} />
    <Redirect from='/saml/auth-request' to='/' />
    <Route component={EmptyPage} />
  </Switch>

export default Routes



// WEBPACK FOOTER //
// ./src/Routes.js